import { render, staticRenderFns } from "./create_update.vue?vue&type=template&id=f32be518&"
import script from "./create_update.vue?vue&type=script&lang=js&"
export * from "./create_update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports